import AnalyticsIcon from '@mui/icons-material/Analytics';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

import { AnalyticsTopicsLink, LTVCoefficientList, MicroTrendsLink } from 'constants/routerPath';

import type { MenuGroup } from './types';

const analytics: MenuGroup = {
    id: 'group-analytics',
    title: 'Analytics',
    type: 'group',
    children: [
        {
            id: 'ltv-coefficient',
            title: 'LTV coefficient',
            type: 'item',
            url: LTVCoefficientList,
            icon: AutoGraphIcon,
            breadcrumbs: false,
            permission_name: 'rebill-rates',
        },
        {
            id: 'analytics-topics',
            title: 'Analytics topics',
            type: 'item',
            url: AnalyticsTopicsLink,
            icon: AnalyticsIcon,
            breadcrumbs: false,
            permission_name: 'analytics-topics',
        },
        {
            id: 'micro-trends',
            title: 'Micro trends',
            type: 'item',
            url: MicroTrendsLink,
            icon: TrendingUpIcon,
            breadcrumbs: false,
            permission_name: 'micro-trends',
        },
    ],
};

export default analytics;
